<template>
  <div class="location-list margins-off">
    <transition-group name="location-item">
      <location-item
        v-for="location in locations"
        :address="location"
        :key="location.timestamp"
        class="small"
      >
        <div class="location-footer margins-off">
          <time :datetime="dateTime(location)" class="location-time">{{
            niceDate(location)
          }}</time>
          <div class="location-controls">
            <DropPinAnchor :location="location" />
            <button
              class="button delete-button"
              @click="$emit('delete', location)"
            >
              <span>
                <icon-x>Delete</icon-x>
              </span>
            </button>
          </div>
        </div>
      </location-item>
    </transition-group>
  </div>
</template>

<script>
import { timeAgoInWords } from "../helpers/timeAgoInWords";
import LocationItem from "@/components/LocationItem";
import DropPinAnchor from "@/components/DropPinAnchor";
import IconX from "@/components/icons/IconX";

export default {
  components: {
    LocationItem,
    DropPinAnchor,
    IconX
  },
  props: {
    locations: Array
  },
  methods: {
    dateTime: function(location) {
      return new Date(location.timestamp).toISOString();
    },

    niceDate: function(location) {
      return timeAgoInWords(location.timestamp);
    }
  }
};
</script>

<style lang="scss">
.location-list {
  perspective: 1200px;

  .location {
    padding-bottom: 2.25em;
  }
}

.location-item-enter,
.location-item-leave-to {
  opacity: 0;
  transform: rotateX(-134deg) scaleY(0.25);
}

.location-item-leave-active {
  position: absolute;
  width: 100%;
}

.button.delete-button {
  color: red;
}
</style>
